
import { useState, useEffect } from "react";
import { ProfileData } from "@/types/profile";
import { getEmptyProfile } from "@/services/profileService";

/**
 * Hook for managing profile state
 */
export const useProfileState = () => {
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [activeTab, setActiveTab] = useState("profile");
  const [profile, setProfile] = useState<ProfileData>(getEmptyProfile());

  // Enhanced profile completeness check - now requires bio, interests, profile picture, grade level, and country
  const isProfileComplete = Boolean(
    profile && 
    typeof profile.full_name === 'string' && 
    profile.full_name.trim() !== '' && 
    typeof profile.username === 'string' && 
    profile.username.trim() !== '' &&
    typeof profile.bio === 'string' &&
    profile.bio.trim() !== '' &&
    typeof profile.interests === 'string' &&
    profile.interests.trim() !== '' &&
    typeof profile.avatar_url === 'string' && // Assuming avatar_url is still desired for completeness
    profile.avatar_url.trim() !== '' &&
    typeof profile.grade_level === 'string' &&
    profile.grade_level.trim() !== '' &&
    typeof profile.country === 'string' &&
    profile.country.trim() !== ''
  );

  // Log profile state changes for debugging
  useEffect(() => {
    console.log("Current profile state:", profile);
    console.log("Full name:", profile?.full_name, "Username:", profile?.username);
    console.log("Bio:", profile?.bio, "Interests:", profile?.interests);
    console.log("Avatar:", profile?.avatar_url, "Grade Level:", profile?.grade_level, "Country:", profile?.country);
    console.log("Is profile complete (useProfileState):", isProfileComplete);
  }, [profile, isProfileComplete]);

  return {
    profile,
    setProfile,
    loading,
    setLoading,
    uploading,
    setUploading,
    activeTab,
    setActiveTab,
    isProfileComplete
  };
};

